import type { LineHeights } from './types';

const lineHeights: LineHeights = {
  button: '0.962rem',
  productName: '120%',
  p3: '1.125rem',
  p2: '1.31rem',
  p1: '1.5rem',
  p0: '1.6rem',
  h6Mobile: '1.1rem',
  h6: '1.1rem',
  h5Mobile: '1.375rem',
  h5: '1.375rem',
  h4Mobile: '1.65rem',
  h4: '1.65rem',
  h3Mobile: '1.925rem',
  h3: '2.34rem',
  h2Mobile: '2.34rem',
  h2: '2.75rem',
  h1Mobile: '2.75rem',
  h1: '3.3rem',
};

export { lineHeights };
